import React from "react";
import { useEffect, useState } from "react";
import { Row, Col, Card, Typography } from "antd";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import LeadsTable from "../components/Leads/LeadsTable";
import { connect } from "react-redux";
import { getAllLeads } from "../store/action/business/LeadAction";
import { getAllAdminLeads } from "../store/action/admin/LeadAdminAction";

const MyLeadsBusiness = (props) => {
  const { Title } = Typography;
  const [leads, setLeads] = useState([]);
  const [value, setValue] = React.useState("one"); // Track the selected tab

  const handleChange = (event, newValue) => {
    setValue(newValue); // Update the selected tab
  };

  useEffect(() => {
    if (props.user && props.user?.role) {
      if (props.user?.role === "admin") {
        props.getAllAdminLeads_();
      } else {
        props.getAllLeads_();
      }
    }
  }, []);

  useEffect(() => {
    if (props.user && props.user?.role) {
      if (props.user?.role === "admin") {
        setLeads(props.allLeadsAdmin);
      } else {
        setLeads(props.allLeads);
      }
    }
  }, [props.allLeadsAdmin, props.allLeads]);

  return (
    <div style={{ padding: 20 }}>
      <Title level={3}>My Leads</Title>
      <Row gutter={20} style={{ marginTop: 20 }}>
        <Col span={24}>
          <div
            style={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <div style={{ minWidth: "900px" }}>
              <LeadsTable leads={leads} mini={false} expand={true} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user?.response,
  allLeadsAdmin: state.allLeadsAdmin?.response?.leads || [],
  allLeads: state.allLeads?.response?.leads || [],
});

const mapDispatchToProps = (dispatch) => ({
  getAllLeads_: () => {
    dispatch(getAllLeads());
  },
  getAllAdminLeads_: () => {
    dispatch(getAllAdminLeads());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MyLeadsBusiness);
